module.exports = __webpack_public_path__ + "media/Video 135b.8fd0ff7f.mp4";